const Store = require('yayson')().Store // tslint:disable-line

export interface IYaysonStore {
  new(): {
    sync(obj: {}): any
    find(type: string, id: string): any
    findAll(type: string): any[]
    remove(type: string, id?: string): void
    reset(): void
    toModel(args1: any, args2: any, args3: any): any

    relations: { [key: string]: any }
  }
}

export const YaysonStore = Store as IYaysonStore



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/json-api-backend/yayson/yayson.store.ts